import Vue from 'vue'
import moment from 'moment'

// 日期過濾器
Vue.filter('datestringformat', function (value, formatStr = 'YYYY/MM/DD') {
  return moment(value).format(formatStr)
})
Vue.filter('datetimeformat', function (value, formatStr = 'YYYY/MM/DD HH:mm') {
  return moment(value).format(formatStr)
})
